export const PROFILE_HEIGHT_PX = 650
export const NAVIGATOR_HEIGHT_PX = 80